enum SubMenuIndexes {
  NEWS = 'sub1',
  GALLERY = 'sub2',
  EXPERT_ARTICLES = 'sub3',
  SETTINGS = 'sub4',
  KNOWLEDGE = 'sub5',
  VIDEO = 'sub6',
  MULTIMEDIA = 'sub7',
  LEXICON = 'sub8',
  PRODUCTS = 'sub9',
  NAWOZY_TV = 'sub10',
  FERTILIZATION = 'sub11',
  FERTILIZATION_SCHEDULE = 'sub12',
  CONTENT_SETTINGS = 'sub13',
  CONTACT = 'sub14',
  BANNERS = 'sub15',
  FERTILIZERS = 'sub16',
  GTW = 'sub18',
  GARDEN = 'sub19',
}

export default SubMenuIndexes;
